export var TutorStatus;
(function (TutorStatus) {
    TutorStatus["IDLE"] = "idle";
    TutorStatus["APPROVED"] = "approved";
    TutorStatus["DISABLED"] = "disabled";
    TutorStatus["PENDING"] = "pending";
    TutorStatus["GRADUATED"] = "graduated";
    TutorStatus["QUIT"] = "quit";
    TutorStatus["REJECTED"] = "rejected";
    TutorStatus["BLOCKED"] = "blocked";
    TutorStatus["DELETED"] = "deleted";
    TutorStatus["DEACTIVATED"] = "deactivated";
    TutorStatus["VOLUNTEER"] = "volunteer";
})(TutorStatus || (TutorStatus = {}));
export var ClientStatus;
(function (ClientStatus) {
    ClientStatus["ACTIVE"] = "active";
    ClientStatus["INACTIVE"] = "inactive";
    ClientStatus["GUEST"] = "guest";
    ClientStatus["VOLUNTEER"] = "volunteer";
    ClientStatus["BLOCKED"] = "blocked";
    ClientStatus["DELETED"] = "deleted";
})(ClientStatus || (ClientStatus = {}));
export var AffiliateStatus;
(function (AffiliateStatus) {
    AffiliateStatus["ACTIVE"] = "active";
    AffiliateStatus["BLOCKED"] = "blocked";
    AffiliateStatus["DELETED"] = "deleted";
})(AffiliateStatus || (AffiliateStatus = {}));
export var AdminStatus;
(function (AdminStatus) {
    AdminStatus["ACTIVE"] = "active";
    AdminStatus["DELETED"] = "deleted";
})(AdminStatus || (AdminStatus = {}));
export var GradeLevel;
(function (GradeLevel) {
    GradeLevel["ELEMENTARY"] = "elementary";
    GradeLevel["MIDDLE"] = "middle";
    GradeLevel["HIGH"] = "high";
    GradeLevel["COLLEGE"] = "college";
})(GradeLevel || (GradeLevel = {}));
export var LanguageLevel;
(function (LanguageLevel) {
    LanguageLevel["NOVICE"] = "novice";
    LanguageLevel["INTERMEDIATE"] = "intermediate";
    LanguageLevel["FLUENT"] = "fluent";
    LanguageLevel["NATIVE"] = "native";
})(LanguageLevel || (LanguageLevel = {}));
export var UserType;
(function (UserType) {
    UserType["TUTOR"] = "tutor";
    UserType["STUDENT"] = "student";
    UserType["PARENT"] = "parent";
    UserType["ADMIN"] = "admin";
    UserType["AFFILIATE"] = "affiliate";
})(UserType || (UserType = {}));
export var Theme;
(function (Theme) {
    Theme["Dark"] = "dark";
    Theme["Light"] = "light";
    Theme["Auto"] = "auto";
})(Theme || (Theme = {}));
export var TutorMode;
(function (TutorMode) {
    TutorMode["Invisible"] = "invisible";
    TutorMode["Active"] = "active";
    TutorMode["Instant"] = "instant";
})(TutorMode || (TutorMode = {}));
//# sourceMappingURL=profile.js.map